import ContactsList from './contacts-list.vue'
export default ContactsList